






import Vue from 'vue';
import { mapGetters } from 'vuex';

import GetResetPassword from '@/web/components/signup/GetResetPassword.vue';

export default Vue.extend({
  name: 'StudioGetResetPassword',
  components: {
    GetResetPassword,
  },
});
